/// <reference types="vite/client" />
import { ServiceId } from '@spectee/graphql/api';

type ServiceMasterType = {
  id: ServiceId;
  name: string;
  displayName: string;
  dispOrder?: number;
  domain?: string;
};

export const serviceMasterData: ServiceMasterType[] = [
  {
    id: 'pro',
    name: 'Spectee Pro',
    displayName: 'Pro',
    dispOrder: 3,
    domain: import.meta.env.VITE_APP_SPECTEE_PRO_DOMAIN,
  },
  {
    id: 'scr',
    name: 'Spectee SCR',
    displayName: 'SCR',
    dispOrder: 1,
    domain: import.meta.env.VITE_APP_SPECTEE_SCR_DOMAIN,
  },
  {
    id: 'srm',
    name: 'スマートリスク管理',
    displayName: 'スマートリスク管理',
    dispOrder: 2,
    domain: import.meta.env.VITE_APP_RISK_MGMT_DOMAIN,
  },
  // リスク監視 will be displayed in cctool. So commenting now.
  // {
  //   id: 'rm',
  //   name: 'リスク監視',
  //   displayName: 'リスク監視',
  //   dispOrder:4,
  //   domain: import.meta.env.VITE_APP_RISK_MNR_DOMAIN,
  // },
  {
    id: 'common',
    name: 'Common',
    displayName: 'Common',
  },
];

export const authorityMasterData = [
  {
    id: 'contractAdministrator',
    roleId: '',
  },
  {
    id: 'groupAdministrator',
    roleId: '',
  },
  {
    id: 'viewer',
    roleId: '',
  },
];
